export default __webpack_public_path__ + "static/hero-sortiment-sustenabil-6114034395ea6706998b0b30fc860e60.jpg";